import HeadComponent, { HeadProps } from './Head';
import { PropsWithChildren } from 'react';

/**
 * A layout that can be used for static pages that should have the appearance of a
 * lightbox / modal, for example the individual post pages under the gallery
 */
const LightboxLayout = (props: PropsWithChildren<HeadProps>) => {
  const { children, seo, schema, pathname, canonicalUrl } = props;

  return (
    <>
      <HeadComponent seo={seo} schema={schema} pathname={pathname} canonicalUrl={canonicalUrl} />

      <div className="!flex min-h-screen items-center justify-center p-16 xs:p-32">
        <div className="flex items-center justify-center">{children}</div>
      </div>
    </>
  );
};

export default LightboxLayout;
